import { Editor as EditorBase, EditorProps } from '@web/tiptap-editor'
import { useAtom } from 'jotai'
import React from 'react'

import { userInfoAtom, usersAtom } from '@/modules/user'

export const Editor: React.FC<Omit<EditorProps, 'viewerEmail' | 'users'>> = (props) => {
  const [viewer] = useAtom(userInfoAtom)
  const [users] = useAtom(usersAtom)
  return <EditorBase {...props} users={users} viewerEmail={viewer.email} />
}
